import { ref } from "vue"
import type { Message as ChatMessage } from "~/stores/messages"
import { decodeMessageContent, type MentionSource } from "~/lib/chat/mentionTokens"

// Module-level singleton: only one message can be edited at a time across the whole chat (matches
// the previous single-list behavior), so this doesn't need to be scoped per MessageItem instance.
const editingMessageId = ref<string | null>(null)
const editContent = ref("")
// The edited message's server-resolved mentions — the composer seeds its picked mentions from them,
// so the readable `@username` / `#name` it shows turn back into the same tokens on save.
const editMentions = ref<MentionSource | null>(null)

export function useMessageEditing() {
  function isEditing(messageId: string): boolean {
    return editingMessageId.value === messageId
  }

  function start(message: ChatMessage) {
    editingMessageId.value = message.id
    // The composer edits readable text, never `<@id>` / `<#id>` tokens (see mentionTokens.ts).
    editContent.value = decodeMessageContent(message)
    editMentions.value = { mentions: message.mentions ?? [], mention_channels: message.mention_channels ?? [], mention_roles: message.mention_roles ?? [] }
  }

  function cancel() {
    editingMessageId.value = null
    editContent.value = ""
    editMentions.value = null
  }

  return { editingMessageId, editContent, editMentions, isEditing, start, cancel }
}
